import { useEffect } from "react";
import { DEFAULT_FOLLOWERS_INTRSECTION_INDEX } from "../../../../../utils";

export const useObserver = (
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
  dependency: number
) => {
  useEffect(() => {
    if (!ref.current) return;

    const children = ref.current.children;
    if (children.length < DEFAULT_FOLLOWERS_INTRSECTION_INDEX) return;

    const targetElement =
      children[children.length - DEFAULT_FOLLOWERS_INTRSECTION_INDEX];
    if (!targetElement) return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries || !entries.length) return;
      const entry = entries[0];
      if (!entry) return;
      if (entry.isIntersecting) callback();
    });

    observer.observe(targetElement);
    return () => observer.disconnect();
    //eslint-disable-next-line
  }, [dependency]);
};
